import { RegistroVacinacaoInput } from 'graphql/types.generated'

import { RegistroVacinacaoFormModel } from '../model'

export const convertRegistroVacinacaoToInput = (formModel: RegistroVacinacaoFormModel[]): RegistroVacinacaoInput[] =>
  formModel?.map((form) => ({
    id: form.id,
    vacinacao: form.vacinacao,
    tipoRegistroVacinacao: form.tipoRegistroVacinacao,
    isRegistroAnterior: form.isRegistroAnterior,
    imunobiologico: form.imunobiologico,
    estrategiaVacinacao: form.estrategiaVacinacao,
    doseImunobiologico: form.doseImunobiologico,
    dataAprazamento: form.dataAprazamento,
    dataAplicacao: form.dataAplicacao,
    loteImunobiologico: form.loteImunobiologico,
    viaAdministracao: form.viaAdministracao,
    localAplicacaoVacinacao: form.localAplicacaoVacinacao,
    observacoes: form.observacoes,
  }))
